import styled, { css } from 'styled-components';
import { Tabs as ATabs } from 'antd';

export default styled(ATabs)`
  height: 100%;

  .ant-tabs-nav-wrap {
    background: white;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-nav .ant-tabs-tab {
    padding: 12px 20px 12px !important;
    font-weight: bold !important;
  }

  .ant-tabs-bar {
    border-bottom: 2px solid #eee;
    background-color: ${(props) => props.color || 'white'};
    margin: 0;
  }

  &.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
    height: auto;
  }

  .ant-tabs-nav-scroll {
    padding: ${(props) => props.padding || '16px 8px 0'};

    ${(props) =>
      props.center &&
      css`
        text-align: center;
      `};
  }

  &.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    color: var(--bluey-grey);
  }

  .ant-tabs-nav .ant-tabs-tab-active {
    color: var(--ultramarine-blue);
    border: none;
    background-color: ${(props) => props.color || 'white'};
    border-bottom: none;
    position: relative;
    z-index: 2;
    font-family: 'Circular-Bold', 'Circular', sans-serif; /* TODO: should expose this as API */
    border-bottom: 4px solid var(--ultramarine-blue);
    padding-bottom: 14px;
    border-radius: 4px;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    text-shadow: none;
  }

  .ant-tabs-nav .ant-tabs-tab:hover {
    color: inherit;
  }

  .ant-tabs-nav .ant-tabs-tab-active:hover {
    color: var(--ultramarine-blue);
  }
`;
